import { render } from "./InkSlab.vue?vue&type=template&id=29d80a75&scoped=true"
const script = {}

import "./InkSlab.vue?vue&type=style&index=0&id=29d80a75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d80a75"]])

export default __exports__